import { makeStyles, Theme, createStyles, Avatar } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import dailyDoseImage from '../../assets/images/daily_dose_icon.png'

import Grid from '@material-ui/core/Grid'

import React, { useContext, useState } from 'react'
import { GroupAddIcon, SearchIcon } from '../../assets/icons'
import {
  AddCircleForm,
  FindSuggestions,
  Loading,
  MyCirclesList,
  NoCircles,
  WelcomeMessageModal,
} from '../../components'
import { firestore } from '../../firebase-init'
import { useDialog } from '../../providers/dialog-provider'
import { FirestoreContext } from '../../providers/firestore-provider'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    small: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
  })
)

export const HomePage = () => {
  const classes = useStyles()
  const { openDialog, closeDialog } = useDialog()
  const circlesRef = firestore.collection('circles')
  const { hasFetchedMyCircles, myCircles } = useContext(FirestoreContext)
  const [isWelcomeMessageModalOpen, setIsWelcomeMessageModalOpen] = useState(false)

  const onCloseWelcomeMessage = () => {
    setIsWelcomeMessageModalOpen(false)
  }

  const onAddCircle = () => {
    openDialog({
      color: 'primary',
      title: 'Add group',
      confirmText: 'Add',
      custom: true,
      description: (
        <AddCircleForm
          circlesRef={circlesRef}
          onAddCircle={() => closeDialog()}
          onCancelCircle={() => closeDialog()}
        />
      ),
      fullScreen: true,
    })
  }

  const onOpenSuggestions = () => {
    openDialog({
      color: 'primary',
      title: 'Find suggestions',
      confirmText: '',
      custom: true,
      description: <FindSuggestions onCancel={() => closeDialog()} />,
      fullScreen: true,
    })
  }

  if (!hasFetchedMyCircles) return <Loading />

  return (
    <Grid
      container
      direction="column"
      justify="flex-start"
      alignItems="flex-start"
      spacing={1}
    >
      <Grid container item xs={12} justify="center">
        <Button
          onClick={() => setIsWelcomeMessageModalOpen(true)}
          variant="text"
          color="primary"
          startIcon={<Avatar src={dailyDoseImage} className={classes.small} />}
          size="large"
          fullWidth
        >
          Welcome to the Daily Dose
        </Button>
      </Grid>
      {!!myCircles.length && (
        <Grid container item xs={12}>
          <Button
            fullWidth
            style={{ textTransform: 'none' }}
            variant="contained"
            color="primary"
            startIcon={<SearchIcon />}
            onClick={onOpenSuggestions}
          >
            Looking for fun?
          </Button>
        </Grid>
      )}
      <Grid item xs={12}>
        <Button
          onClick={onAddCircle}
          variant="text"
          color="primary"
          startIcon={<GroupAddIcon />}
          size="large"
        >
          Add Group
        </Button>
      </Grid>

      {!!myCircles.length ? (
        <MyCirclesList />
      ) : (
        <NoCircles onGoToAddCircle={onAddCircle} />
      )}
      {isWelcomeMessageModalOpen && (
        <WelcomeMessageModal
          onClose={onCloseWelcomeMessage}
          open={isWelcomeMessageModalOpen}
        />
      )}
    </Grid>
  )
}
